import React from 'react';
import { useSelector } from 'react-redux';
import Actions from '../Actions';
import Empty from '../Empty';
import Tenant from '../Tenant';
import Avatar from '../Avatar';
import { Link } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import { selectSearch } from 'src/store/selectors/search';
import Table from '../Table';
import { onRequestPhoneCall } from 'src/helpers/validationHelper';
import Search from 'src/components/Search/Search';
import { useTablePagination } from 'src/SharedCustomHooks/UseTablePagination/useTablePagination';

const KeyContactsTable = ({ keyContacts, onSearch }) => {
  const search = useSelector(selectSearch);

  const theme = localStorage.getItem('theme');

  const { itemsPerPage, onItemsPerPageChange } = useTablePagination();

  return (
    <>
      <Actions compact>
        <Search
          size="small"
          placeholder="Search Key Contacts..."
          onChange={onSearch}
          theme={undefined}
        />
      </Actions>
      {keyContacts.length > 0 ? (
        <div
          style={{
            height: 550,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Table
            columns={
              theme === 'Shape'
                ? [
                    {
                      label: 'Key Contact',
                      sortable: true,
                      accessor: 'name',
                      cell: (data) => {
                        return (
                          <Link
                            to={{
                              pathname: PATHS.KEY_CONTACTS_VIEW.replace(
                                ':id',
                                data.id
                              ),
                              state: { keyContact: data },
                            }}
                          >
                            <Tenant
                              headline={`${data.name}`}
                              avatar={<Avatar url={data.profileImage} />}
                            />
                          </Link>
                        );
                      },
                    },

                    {
                      label: 'Phone',
                      accessor: 'phone',
                      cell: (data) => onRequestPhoneCall(data.phone),
                    },
                    {
                      xsHide: true,
                      label: 'Email',
                      accessor: 'email',
                    },
                  ]
                : [
                    {
                      label: 'Key Contact',
                      sortable: true,
                      accessor: 'name',
                      cell: (data) => {
                        return (
                          <Link
                            to={{
                              pathname: PATHS.KEY_CONTACTS_VIEW.replace(
                                ':id',
                                data.id
                              ),
                              state: { keyContact: data },
                            }}
                          >
                            <Tenant
                              headline={`${data.name}`}
                              avatar={<Avatar url={data.profileImage} />}
                            />
                          </Link>
                        );
                      },
                    },
                    {
                      label: 'Description',
                      accessor: 'department',
                    },
                    {
                      label: 'Phone',
                      accessor: 'phone',
                      cell: (data: any) => onRequestPhoneCall(data.phone),
                    },
                    {
                      xsHide: true,
                      label: 'Email',
                      accessor: 'email',
                    },
                  ]
            }
            data={keyContacts}
            paginate={{ itemsPerPage, position: 'both' }}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        </div>
      ) : (
        <Empty
          direction="ttb"
          headline="No key contacts yet"
          strapline=" all your key contacts here so it's easier for you to manage."
          searchIsActive={search && search.contacts ? search.contacts : ''}
          cta={null}
          image={
            <img alt="No key contacts yet" src="/assets/empty/contacts.svg" />
          }
        />
      )}
    </>
  );
};

export default KeyContactsTable;
